
(() => {
  'use strict';


const SOURCE_TEXTS = {
  da: ['Sendes hverdage kl. 17'],
  sv: [
    'Köp före 17 – skickas idag',
    'Skickas vardagar kl. 17'
  ],
  no: ['Sendes hverdager kl. 17'],
  nb: ['Sendes hverdager kl. 17'],
  nl: [
    'Op voorraad',
    'Verzonden op werkdagen om 17.00 uur'
  ],
  fr: ['Expédié les jours ouvrables à 17 h'],
  fi: [
    'Tilaa ennen klo 17 – lähetetään tänään',
    'Lähetetään arkisin klo 17'
  ],
  pl: ['Wysyłka w dni robocze o 17:00'],
  sl: [
  'Odpošlje se ob delovnikih ob 17:00',
  'Odprema ob delavnikih ob 17. uri'
],
  sk: ['Odosielame v pracovné dni o 17:00'],
  el: ['Αποστέλλεται τις εργάσιμες ημέρες στις 17:00'],
  it: ['Spedizione nei giorni lavorativi alle 17:00'],
  cs: ['Odesíláme v pracovní dny v 17:00'],
  hu: ['Munkanapokon 17:00-kor feladva'],
  bg: ['Изпраща се в работни дни в 17:00'],
  en: ['Dispatched on weekdays at 17:00']
};


  const DICT = {
    da: ['Bestil inden', 'Afsendes i dag', 'Afsendes', 'timer', 'min.', 'og', ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']],
    sv: ['Beställ inom', 'Skickas idag', 'Skickas', 'timmar', 'minuter', 'och', ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']],
    no: ['Bestill innen', 'Sendes i dag', 'Sendes', 'timer', 'minutter', 'og', ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']],
    nl: ['Bestel binnen', 'Vandaag verzonden', 'Verzending op', 'uur', 'minuten', 'en', ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']],
    fr: ['Commandez dans', 'Expédié aujourd’hui', 'Expédition', 'heures', 'minutes', 'et', ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']],
    fi: ['Tilaa seuraavan ajan kuluessa:', 'Lähetetään tänään', 'Lähetetään', 'tuntia', 'minuuttia', 'ja', ['sunnuntaina', 'maanantaina', 'tiistaina', 'keskiviikkona', 'torstaina', 'perjantaina', 'lauantaina']],
    pl: ['Zamów w ciągu', 'Wysyłka dzisiaj', 'Wysyłka', 'godz.', 'min', 'i', ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']],
    sl: ['Naročite v naslednjih', 'Odprema danes', 'Odprema', 'ur', 'minut', 'in', ['nedeljo', 'ponedeljek', 'torek', 'sredo', 'četrtek', 'petek', 'soboto']],
    sk: ['Objednajte do', 'Odosielame dnes', 'Odosielame', 'hod.', 'min.', 'a', ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota']],
    el: ['Παραγγείλτε εντός', 'Αποστέλλεται σήμερα', 'Αποστολή', 'ωρών', 'λεπτών', 'και', ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο']],
    it: ['Ordina entro', 'Spedizione oggi', 'Spedizione', 'ore', 'minuti', 'e', ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato']],
    cs: ['Objednejte do', 'Odesíláme dnes', 'Odesíláme', 'hod.', 'min.', 'a', ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota']],
    hu: ['Rendeljen', 'Ma feladjuk', 'Feladás', 'óra', 'perc', 'és', ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat']],
    bg: ['Поръчайте до', 'Изпращаме днес', 'Изпращане', 'часа', 'минути', 'и', ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'péntek', 'събота']],
    en: ['Order within', 'Ships today', 'Ships', 'hours', 'minutes', 'and', ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']]
  };

  const LANG_ALIASES = {
    nb: 'no',
    nn: 'no',
    cz: 'cs',
    gr: 'el'
  };

  const dayIndex = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const dtf = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Copenhagen',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  const lang0 = (document.documentElement.lang || 'en')
    .toLowerCase()
    .split('-')[0];

  const lang = LANG_ALIASES[lang0] || lang0;
  const t = DICT[lang] || DICT.en;

  function time() {
    const p = Object.fromEntries(
      dtf.formatToParts(new Date())
        .filter(x => x.type !== 'literal')
        .map(x => [x.type, x.value])
    );

    const day = dayIndex.indexOf(p.weekday);

    return {
      day,
      secs:
        Number(p.hour) * 3600 +
        Number(p.minute) * 60 +
        Number(p.second)
    };
  }

  function render(el) {
    if (!el.isConnected) return;

    const { day, secs } = time();

    if (day < 0) return;

    const before =
      day >= 1 &&
      day <= 5 &&
      secs < 61200;

    let line1 = '';
    let line2 = '';

    if (before) {
      const left = 61200 - secs;
      const hours = Math.floor(left / 3600);
      const minutes = Math.ceil((left % 3600) / 60);

      if (minutes === 60) {
        line1 = `${t[0]} ${hours + 1} ${t[3]}`;
      } else {
        line1 =
          `${t[0]} ${hours} ${t[3]} ${t[5]} ${minutes} ${t[4]}`;
      }

      line2 = t[1];
    } else {
      const offset =
        day === 5 ? 3 :
        day === 6 ? 2 :
        day === 0 ? 1 : 1;

      line2 = `${t[2]} ${t[6][(day + offset) % 7]}`;
    }

    const current = el.querySelector(
      '.bilmedie-shipping-countdown'
    );

    const status = el.querySelector(
      '.bilmedie-shipping-result'
    );

    if (
      !status ||
      (before && !current) ||
      (!before && current)
    ) {
      el.replaceChildren();

      if (before) {
        const a = document.createElement('span');
        a.className = 'bilmedie-shipping-countdown';
        a.textContent = line1;
        el.append(a);
      }

      const b = document.createElement('strong');
      b.className = 'bilmedie-shipping-result';
      b.textContent = line2;
      el.append(b);
    } else {
      if (current && current.textContent !== line1) {
        current.textContent = line1;
      }

      if (status.textContent !== line2) {
        status.textContent = line2;
      }
    }
  }

  function scan() {
    document.querySelectorAll(
      '.iia-container .iia-location'
    ).forEach(el => {
      if (el.dataset.bilmedieShipping === '1') return;

const acceptedTexts = [
  ...SOURCE_TEXTS.da,
  ...(SOURCE_TEXTS[lang] || [])
];

if (!acceptedTexts.includes(el.textContent.trim())) return;

      el.dataset.bilmedieShipping = '1';
      el.classList.add('bilmedie-shipping-status');

      render(el);
    });
  }

  function tick() {
    scan();

    document.querySelectorAll(
      '.iia-location[data-bilmedie-shipping="1"]'
    ).forEach(el => {
      if (!el.querySelector('.bilmedie-shipping-result')) {
        delete el.dataset.bilmedieShipping;
        el.classList.remove('bilmedie-shipping-status');
        return;
      }

      render(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick, {
      once: true
    });
  } else {
    tick();
  }

  window.addEventListener('load', tick);

  setInterval(tick, 30000);

  const observer = new MutationObserver(() => {
    if (!document.querySelector(
      '.iia-container .iia-location'
    )) return;

    scan();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();


/* Bilmedie – lokale fragtlogoer */
function updateLocalShippingLogo() {
  const hostname = window.location.hostname.replace(/^www\./, '');

  const logos = {
    'carmedia24.nl': {
      url: 'https://cdn.shopify.com/s/files/1/0820/5467/6808/files/postnl-logo.png?v=1792457209',
      alt: 'PostNL',
      cssClass: 'bilmedie-postnl-logo'
    },
    'carmedia24.si': {
      url: 'https://cdn.shopify.com/s/files/1/0820/5467/6808/files/postaslovenia.png?v=1792457615',
      alt: 'Pošta Slovenije',
      cssClass: 'bilmedie-posta-slovenia-logo'
    }
  };

  const logo = logos[hostname];
  if (!logo) return;

  document.querySelectorAll(
    '.iia-container .iia-list-item img'
  ).forEach(img => {
    if (!img.src.toLowerCase().includes('postnord')) return;

    img.src = logo.url;
    img.alt = logo.alt;
    img.classList.add(logo.cssClass);
  });
}

updateLocalShippingLogo();

new MutationObserver(updateLocalShippingLogo).observe(document.body, {
  childList: true,
  subtree: true
});
